import classNames from 'classnames'
import { t } from 'i18next'
import { Dropdown } from 'primereact/dropdown'
import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { Person } from '../../../../../model/person.model'
import { useAppSelector } from '../../../../../redux/hooks'
import { findPersonById } from '../../../../../util/arraySearch'
import { sortByFirstName } from '../../../../../util/sortByFirstName'
import { AvatarWithName } from '../../../AvatarWithName'
import {
  getFormErrorMessage,
  getRequiredFormMessage,
} from '../../../ErrorText'

export const EmployeeDropdown = (props: {
  isDisabled?: boolean;
  fieldName: string;
  isCompulsory?: boolean;
}) => {
  const employees: Person[] = useAppSelector((state) => state.employees)

  const {
    control,
    setValue,
    formState: { errors },
  } = useFormContext()

  const selectedPersonTemplate = (personId: number | undefined) => {
    if (personId && personId > 0) {
      const person = findPersonById(personId, employees)
      if (person) {
        return <AvatarWithName person={person} />
      }
      console.warn(
        `Person with ID '${personId}' in person-dropdown selected but not found in list.`
      )
    }

    return undefined
  }

  const personOptionTemplate = (person: Person) => {
    return <AvatarWithName person={person} />
  }

  return (
    <>
      {props?.fieldName === 'id_responsible' && (
        <label
          htmlFor={props.fieldName}
          className={classNames({ 'p-error': errors.props?.fieldName })}
        >
          {t<string>('core.responsible')}
        </label>
      )}
      <Controller
        name={props.fieldName}
        control={control}
        rules={
          props.isCompulsory
            ? {
                required: getRequiredFormMessage('core.ausbilder.neutral'),
                validate: (value) => value !== 0,
              }
            : {}
        }
        render={({ field, fieldState }) => (
          <Dropdown
            id={field.name}
            appendTo={document.body}
            options={[...employees].sort(sortByFirstName)}
            onChange={(e) => {
              // we have the apprentice object and want to set the id
              field.onChange(e.target.value?.person_id)
              setValue(field.name, e.target.value?.person_id, {
                shouldDirty: true,
              })
            }}
            optionLabel="full_name"
            placeholder={t<string>('core.select')}
            filter
            showClear
            filterBy="full_name"
            valueTemplate={selectedPersonTemplate(field.value)}
            itemTemplate={personOptionTemplate}
            className={classNames(
              { 'p-invalid': fieldState.error },
              ' people-dropdown w-full'
            )}
            emptyMessage={t<string>('core.empty_message')}
            emptyFilterMessage={t<string>('core.empty_filter_message')}
            disabled={props?.isDisabled}
          />
        )}
      />
      {getFormErrorMessage(errors, props.fieldName)}
    </>
  )
}